export function requestInfo() {
    const node_id = localStorage.getItem("nodeId");
    const store_id = localStorage.getItem("storeId");
    const user_id = localStorage.getItem("userId");

    return {
        info: {
            node_id,
            user_id: user_id ? parseInt(user_id) : -1
        },
        store_id
    };
}

export function deviceSetup(data) {
    // console.log("Setup: ", deviceId, data)

    if (data.node) localStorage.setItem("nodeId", data.node);
    localStorage.setItem("token", data.token);
    localStorage.setItem("accountId", data.account_id);
    localStorage.setItem("storeId", data.store.id);
    localStorage.setItem("storeName", data.store.name);

    // klStoreId is kitchen line reference id. used where cloud kitchen is accessed.
    // by default store id is klStoreId
    let klStoreId = data.store.id;
    if (data.kl_store_id) {
        klStoreId = data.kl_store_id;
    }
    localStorage.setItem("klStoreId", klStoreId);

    //handle response data is valid to avoid recursion while validating client
    return validateDevice();
}

export function clearLocalStorage() {
    localStorage.removeItem("nodeId");
    localStorage.removeItem("token");
    localStorage.removeItem("accountId");
    localStorage.removeItem("storeId");
    localStorage.removeItem("storeName");
    localStorage.removeItem("klStoreId");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("privileges");
    localStorage.removeItem("kitchenLine");
    localStorage.removeItem("isLineRestricted");
    localStorage.removeItem("notifications");
}

export function validateDevice() {
    // let nodeId = localStorage.getItem("nodeId", nodeId);
    // let token = localStorage.getItem("token");
    let accountId = localStorage.getItem("accountId");
    let storeId = localStorage.getItem("storeId");
    let storeName = localStorage.getItem("storeName");

    if (accountId && storeId && storeName) {
        return true
    }

    return false
}